import { render, staticRenderFns } from "./TypeToolsManage.vue?vue&type=template&id=01660da3&"
import script from "./TypeToolsManage.vue?vue&type=script&lang=js&"
export * from "./TypeToolsManage.vue?vue&type=script&lang=js&"
import style0 from "./TypeToolsManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports